import axiosInstance from '~/common/helpers/axiosInstance';
import { Trigger } from '~/entities/Trigger';

type RawTrigger = Omit<Trigger, 'jsonSchema' | 'documentationURL'> & {
  jsonSchema?: Array<{ documentationURL?: string }>;
};

export async function getTriggers(realm: string): Promise<Trigger[]> {
  const { data } = await axiosInstance.get<RawTrigger[]>(
    `design/realms/${encodeURIComponent(realm)}/triggers`
  );

  return data.map(trigger => ({
    ...trigger,
    documentationURL: trigger.jsonSchema?.[0]?.documentationURL,
    jsonSchema: trigger.jsonSchema ?? []
  })) as unknown as Trigger[];
}
